import { HomeIssue } from './HomeIssue'
import { HomeQualityCheckStatus, HomeQualityCheckSummary } from './HomeQualityCheck'
import { MarketSegmentFilterParams } from './MarketSegment'
import { Property, ReservationProperty } from './Property'
import { Ticket } from './Ticket'

export interface HomesFilterParams extends MarketSegmentFilterParams {
  autopilot: boolean
  blocked: boolean
  direct: boolean
  installed: boolean
  leased: boolean
  limit: number
  newOD: boolean
  notReady: boolean
  occupied: boolean
  published: boolean
  scheduledForDeinstall: boolean
  vacant: boolean
}

export enum AccessType {
  CHECKIN = 'Check-In',
  CHECKOUT = 'Checkout',
  PARKING = 'Parking',
}

export enum UserType {
  ADMIN = 'Admin',
  ANYONE = 'Anyone',
  HOST = 'Host',
  MEMBER = 'Member',
}

export interface HomesResponse extends Home {
  blocked: boolean
  earliestAvailableDate?: string
  homeQualityStatus: HomeQualityCheckStatus
  installed: boolean
  property: Partial<Property>
  published: boolean
  searchDocument: string
  vacantDays: number | null
}

export interface Home {
  baths: string
  bedrooms: number
  id: number
  unitNumber: string
}

export interface ReservationHome extends Home {
  accessInstructions?: AccessInstruction[]
  accessInstructionsSetup?: string
  airConditioningAvailability?: number
  blocked?: boolean
  floor?: number
  floorplanId?: number
  hasBalcony: boolean
  inUnitLaundry?: boolean
  laundry?: string
  leasedParkingSpots?: LeasedParkingSpots[]
  leases?: Lease[]
  lockType?: string
  mailBoxNumber?: string
  notes?: string
  occupied: boolean
  property: Partial<ReservationProperty>
  propertyOnlinePortal?: string
  propertyPortalPassword?: string
  propertyPortalUsername?: string
  recordBlockReasons?: recordBlockReasons[]
  searchDocument: string
  slug: string
  uninstallDate?: string
  unitContactAddress?: string
  unitContactEmail?: string
  unitContactPhone?: string
}

export interface recordBlockReasons {
  blockReason?: {
    description?: string
  }
  id: number
}

export interface Lease {
  active: boolean
  createdAt?: string
  endsOn?: string
  leaseType?: string
  renewalStatus?: string
  startsOn?: string
  updatedAt?: string
}

export interface AccessInstruction {
  accessType: AccessType
  accessibleId: number
  accessibleType: string
  id: number
  instruction: string
  name: string
  userType: UserType
}

export interface LeasedParkingSpots {
  spotDetails: string
  spotNumber: string
  status: string
}

export interface HomeTimeline {
  currentReservationId?: number
  homeIssues?: HomeIssue[]
  homeQualityChecks: HomeQualityCheckSummary[]
  previousReservationId?: number
  previousReservationMoveOutDate?: string
  searchDocument: string
  tickets: TimelineTicket[] | null
  timeline?: Timeline[]
  upcomingMoveInDate?: string
  upcomingReservationId?: number
}

export interface Timeline {
  date: string
  events: TimelineEvent[]
}

export interface TimelineEvent {
  date: string
  event: string
  eventId: number
  eventType: string
  outcome: string
  party: string
}

export interface TimelineTicket extends Ticket {
  assignee?: {
    fullName: string | null
  }
  closedAt: string | null
  contact?: {
    fullName: string | null
  }
  lastCommentDatetime: string | null
  reservation: null | {
    professionalHousing: null | boolean
    standby: null | boolean
  }
}

export interface HomeInventoryItem {
  name?: string
}
